import { createAsyncThunk } from '@reduxjs/toolkit';
import { Color } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchColor, FindColor, GetColor } from './interface';

export const findColor = createAsyncThunk(
  'color/findColor',
  async (values: FindColor, { rejectWithValue }) => {
    try {
      const response = await Color.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createColor = createAsyncThunk(
  'color/createColor',
  async (values: CreatePatchColor, { rejectWithValue }) => {
    try {
      const response = await Color.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchColor = createAsyncThunk(
  'color/patchColor',
  async ({ id, ...values }: CreatePatchColor, { rejectWithValue }) => {
    try {
      const response = await Color.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getColor = createAsyncThunk(
  'color/getColor',
  async ({ id }: GetColor, { rejectWithValue }) => {
    try {
      const response = await Color.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);